module.exports = __webpack_public_path__ + "static/media/halugen-card-logo.ad3a6617.png";